<div class="iz-container" [class.iz-container--mapping]="step === 3">
  <div class="iz-header">
    <h2 class="iz-title">{{ step === 3 ? 'Field Mapping' : 'Import from Zephyr Essential' }}</h2>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="onBack()"
      aria-label="Close">
      <img
        [src]="isActive ? 'assets/images/virtusa-icons/close-dark.svg' : 'assets/images/virtusa-icons/close.svg'"
        alt="Close"/>
    </button>
  </div>

  <div class="iz-body" *ngIf="step === 2">
    <div *ngIf="isLoadingFolders" class="iz-folders-loading" role="status" aria-live="polite">
      <span class="spinner-border" aria-hidden="true"></span>
      <span>Loading folders...</span>
    </div>
    <aside class="iz-folders" aria-label="Folders" *ngIf="!isLoadingFolders">
      <p class="iz-folders-title">Folders</p>
      <p *ngIf="foldersError" class="iz-folders-status iz-folders-status--error">{{ foldersError }}</p>
      <p *ngIf="!foldersError && folders.length === 0" class="iz-folders-status">No folders found.</p>
      <div *ngIf="folders.length" class="iz-folder-tree" role="tree">
        <ng-container *ngTemplateOutlet="folderNodes; context: { $implicit: folders, level: 0 }"></ng-container>
      </div>
    </aside>

    <section class="iz-cases" aria-label="Test cases" *ngIf="!isLoadingFolders">
      <app-expandable-accordion
        [data]="testCaseView"
        [retainedSelectionIds]="retainedSelectionIds"
        [showEmptyState]="true"
        [showSelectAll]="testCaseView.rows.length > 0"
        [showHeader]="testCaseView.rows.length > 0"
        [showFeedbackActions]="false"
        [showStoryIdLink]="true"
        [showEditButton]="false"
        [showExpandButton]="false"
        [pageSize]="10"
        (actionEmit)="onTestCasesAction($event)"
      >
        <div class="iz-selection-summary" accordionSummary *ngIf="selectedTestCaseCount > 0">
          <span class="iz-selection-stat">
            <img src="assets/images/virtusa-icons/folder.svg" alt="" />
            {{ selectedFolderCount }} Sub folder Selected
          </span>
          <span class="iz-selection-stat">
            <img src="assets/images/virtusa-icons/document-icon.svg" alt="" />
            {{ selectedTestCaseCount }} Test case{{ selectedTestCaseCount === 1 ? '' : 's' }} Selected
          </span>
        </div>
      </app-expandable-accordion>
    </section>
  </div>

  <div class="iz-mapping" *ngIf="step === 3">
    <app-field-mapping
      [fields]="mappingFields"
      [columns]="mappingColumns"
      sourceLabel="Zephyr Essential Field"
      [showRequiredMark]="false"
      [filledSelect]="true"
      idPrefix="iz-map"
      [mappings]="fieldMappings">
    </app-field-mapping>
  </div>

  <p class="iz-mapping-error" *ngIf="mappingError">{{ mappingError }}</p>

  <div class="iz-footer">
    <span class="iz-step-label">Step {{ step }} of 3</span>
    <div class="iz-footer-actions">
      <button type="button" class="btn-accello-secondary mx-2" (click)="onBack()" [disabled]="isLoadingMapping || isImporting">Cancel</button>
      <button
        type="button"
        class="btn-accello-primary-light d-inline-flex align-items-center gap-2"
        [disabled]="continueDisabled"
        (click)="onContinue()">
        <span *ngIf="isLoadingMapping || isImporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ continueLabel }}
      </button>
    </div>
  </div>
</div>

<ng-template #folderNodes let-nodes let-level="level">
  <div
    *ngFor="let folder of nodes; trackBy: trackFolder"
    class="iz-folder-branch"
    role="treeitem"
    [attr.aria-expanded]="folder.children.length ? isExpanded(folder.id) : null"
    [attr.aria-selected]="isSelected(folder.id)">
    <button
      type="button"
      class="iz-folder-row"
      [class.iz-folder-row--selected]="isSelected(folder.id)"
      [style.padding-left.px]="12 + level * 20"
      (click)="selectFolder(folder)">
      <span
        class="iz-folder-toggle"
        [class.iz-folder-toggle--open]="isExpanded(folder.id)"
        [class.iz-folder-toggle--leaf]="folder.children.length === 0"
        (click)="folder.children.length ? toggleFolder(folder, $event) : null"
        [attr.aria-hidden]="folder.children.length === 0 ? true : null"
        [attr.aria-label]="folder.children.length ? (isExpanded(folder.id) ? 'Collapse ' + folder.name : 'Expand ' + folder.name) : null">
        <svg *ngIf="folder.children.length" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
          <path d="M4 2.5L7.5 6L4 9.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <svg class="iz-folder-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M2.2 4.6c0-.9.7-1.6 1.6-1.6h2.2l1.1 1.3h5.1c.9 0 1.6.7 1.6 1.6v6.1c0 .9-.7 1.6-1.6 1.6H3.8c-.9 0-1.6-.7-1.6-1.6V4.6z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
      <span class="iz-folder-copy">
        <span class="iz-folder-name">{{ folder.name }}</span>
        <span class="iz-folder-meta">
          {{ folderMeta(folder) }}
          <span *ngIf="selectedCount(folder) > 0" class="iz-folder-selected">
            · {{ selectedCount(folder) }} selected
          </span>
        </span>
      </span>
    </button>

    <div *ngIf="folder.children.length && isExpanded(folder.id)" class="iz-folder-children" role="group">
      <ng-container *ngTemplateOutlet="folderNodes; context: { $implicit: folder.children, level: level + 1 }"></ng-container>
    </div>
  </div>
</ng-template>
